import type { FormInputTypeSelect, FormInputTypeTextarea } from '@/components/UI/Form/types'

// In the future, we envision this to be a generalize FormInput[]
// but the type is super specific for now.
export type TutorQuestionnaireFormInputType =
  | (FormInputTypeTextarea & { label: string })
  | (FormInputTypeSelect & { options: { label: string; value: string }[]; label: string })

export type TutorQuestionnaire = TutorQuestionnaireFormInputType[]

export function getTutorQuestionnaireQuestion(
  questionnaire: TutorQuestionnaire | null
): string | null {
  if (questionnaire == null || questionnaire.length !== 1) {
    return null
  }
  return questionnaire[0].label
}

export function createTutorQuestionnaire(question: string | null): TutorQuestionnaire | null {
  return question == null || question.length === 0
    ? null
    : [
        {
          type: 'textarea',
          name: 'welcome_question',
          size: 6,
          label: question,
          placeholder: 'Enter your response here...',
          required: true,
        },
      ]
}
